import * as api from '../api/directMessages';
import { INBOX_LOAD_MORE_CONVERSATIONS } from '../actions';

const loadMoreConversationsStarted = (dispatch, payload) =>
  dispatch({
    type: INBOX_LOAD_MORE_CONVERSATIONS,
    status: 'started',
    payload,
  });

const loadMoreConversationsSuccess = (dispatch, payload) =>
  dispatch({
    type: INBOX_LOAD_MORE_CONVERSATIONS,
    status: 'success',
    payload,
  });

const loadMoreConversationsError = (dispatch, payload) =>
  dispatch({
    type: INBOX_LOAD_MORE_CONVERSATIONS,
    status: 'error',
    payload,
  });

const loadMoreConversations =
  (includeClosed = false, page = 1) =>
  async (dispatch) => {
    loadMoreConversationsStarted(dispatch, { page });

    try {
      const { conversations, totalCount } =
        await api.conversations.fetchConversations(includeClosed, page);
      loadMoreConversationsSuccess(dispatch, {
        conversations,
        totalCount,
        page,
      });
    } catch (error) {
      loadMoreConversationsError(dispatch, { error });
    }
  };

export default loadMoreConversations;
